import * as Types from './workstationActionTypes.js'

const initialState = {
    workstations: [],
    zones: [],
    machineParameters: [],
    activeWorkstations: [],
    selectedWorkstation: 0,
    selectedZone: null,
    workstationNotificationsDrawerOpen: false,
    noSelectedWorkstation: false,
    operators: [],
    restrictions: [],
    workingHours: [],
    restrictionTypes: []
};

export default function workstation(state = initialState, action) {
    switch (action.type) {
        case Types.SET_WORKSTATIONS:
            if (state.workstations !== action.workstations) {
                return Object.assign({}, state, { workstations: action.workstations });
            }
            return state;
        case Types.SET_ZONES:
            if (state.zones !== action.zones) {
                return Object.assign({}, state, { zones: action.zones });
            }
            return state;
        case Types.SET_MACHINEPARAMETERS:
            if (state.machineParameters !== action.parameters) {
                return Object.assign({}, state, { machineParameters: action.parameters });
            }
            return state;
        case Types.SET_ACTIVEWORKSTATIONS:
            if (state.activeWorkstations !== action.activeWorkstations) {
                return Object.assign({}, state, { activeWorkstations: action.activeWorkstations });
            }
            return state;
        case Types.SET_SELECTEDWORKSTATION:
            if (state.selectedWorkstation !== action.selectedWorkstation) {
                return Object.assign({}, state, { selectedWorkstation: action.selectedWorkstation });
            }
            return state;
        case Types.SET_SELECTEDZONE:
            if (state.selectedZone !== action.selectedZone) {
                return Object.assign({}, state, { selectedZone: action.selectedZone });
            }
            return state;
        case Types.SET_NOSELECTEDWORKSTATION:
            if (state.noSelectedWorkstation !== action.noSelectedWorkstation) {
                return Object.assign({}, state, { noSelectedWorkstation: action.noSelectedWorkstation });
            }
            return state;
        case Types.SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN:
            if (state.workstationNotificationsDrawerOpen !== action.workstationNotificationsDrawerOpen) {
                return Object.assign({}, state, { workstationNotificationsDrawerOpen: action.workstationNotificationsDrawerOpen });
            }
            return state;
        case Types.SET_OPERATORS:
            if (state.operators !== action.operators) {
                return Object.assign({}, state, { operators: action.operators });
            }
            return state;
        case Types.SET_RESTRICTIONS:
            if (state.restrictions !== action.restrictions) {
                return Object.assign({}, state, { restrictions: action.restrictions });
            }
            return state;
        case Types.SET_WORKINGHOURS:
            if (state.workingHours !== action.workingHours) {
                return Object.assign({}, state, { workingHours: action.workingHours });
            }
            return state;
        case Types.SET_RESTRICTIONTYPES:
            if (state.restrictionTypes !== action.restrictionTypes) {
                return Object.assign({}, state, { restrictionTypes: action.restrictionTypes });
            }
            return state;
        default:
            return state;
    }
}